import React, {useRef, useState} from 'react';
import ValidationGroup from 'devextreme-react/validation-group';

import {LLBtn2, withCommon, llNotifier} from '../../components';
import {FormSecondPart, turkishId} from '../forms/sign-up/components';
import {DrawerCloseButton} from '../../pages/user-profile/components';

const stringToDate = (value) => {
    const tempArr = String(value).split('-');
    return new Date(new Date(new Date(new Date().setDate(tempArr[0])).setMonth(tempArr[1] - 1)).setYear(tempArr[2]));
};

const EasyMembershipPersonalForm = withCommon({
    store: ({store}) => ({
        viewSize: store.site.status.viewSize,
        savePersonalInfo: store.user.savePersonalInfo,
        showMembershipResult: store.user.showMembershipResult,
    }),
    defaultName: 'EasyMembershipPersonalForm',
    isObserver: true,
    isTrans: true,
})(({
    trans,
    viewSize,
    savePersonalInfo,
    showMembershipResult,
}) => {
    const formRef = useRef(null);
    const submittingRef = useRef(false);
    const [form, setForm] = useState({
        name: '',
        surname: '',
        gender: 'M',
        dateOfBirth: new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
        countryCode: 'TR',
        city: '',
        address: '',
        idNumber: '',
        phone: '',
        currency: 'TRY',
    });
    const [serverResponseErrors, setServerResponseErrors] = useState({});
    const [isSubmitFetching, setSubmitFetching] = useState(false);

    const clearServerError = (type) => {
        if (serverResponseErrors[type]) {
            const tempObj = {...serverResponseErrors};
            delete tempObj[type];
            setServerResponseErrors(tempObj);
        }
    };

    const serverValidationCheck = (e, fieldName) => {
        if (
            fieldName === 'idNumber' &&
            form.countryCode === 'TR' &&
            !serverResponseErrors[fieldName]
        ) {
            return turkishId.validate(e.value);
        } else if (fieldName === 'dateOfBirth') {
            let now = new Date();
            let m = now.getMonth();
            now.setFullYear(now.getFullYear() - 18);
            if (m !== now.getMonth()) now.setDate(0);
            return serverResponseErrors.dateOfBirth?.length ? false : now >= stringToDate(e.value);
        }
        return !serverResponseErrors[fieldName];
    };

    const submit = () => {
        if (submittingRef.current) {
            return;
        }
        submittingRef.current = true;
        setSubmitFetching(true);
        let customerName = form.name;
        let customerSurname = form.surname;
        if (form.countryCode === 'TR') {
            customerName = customerName.toLocaleUpperCase('TR');
            customerSurname = customerSurname.toLocaleUpperCase('TR');
        } else {
            customerName = customerName.toUpperCase();
            customerSurname = customerSurname.toUpperCase();
        }
        const data = {
            name: customerName,
            surname: customerSurname,
            idNumber: form.idNumber,
            phone: form.phone,
            country: form.countryCode,
            city: form.city,
            addr: form.address,
            dateOfBirth:
                form.dateOfBirth.getFullYear() +
                ('0' + (form.dateOfBirth.getMonth() + 1)).slice(-2) +
                ('0' + form.dateOfBirth.getDate()).slice(-2),
            sex: form.gender,
        };
        savePersonalInfo(data).then((response) => {
            submittingRef.current = false;
            setSubmitFetching(false);
            if (!response) {
                llNotifier({message: 'GENERAL_ERROR', type: 'error'});
                return;
            }
            if (!response.success) {
                if (response.data?.error === 'IDENTITY_NOT_VERIFIED') {
                    showMembershipResult(false);
                    return;
                }
                setServerResponseErrors(response.data || {});
                if (formRef.current?.instance) {
                    formRef.current.instance.validate();
                }
                const firstError = response.data?.error || response.data?.name_surname;
                if (firstError && typeof firstError === 'string') {
                    llNotifier({message: firstError, type: 'error', withTranslation: true});
                }
                return;
            }
            showMembershipResult(true);
        });
    };

    return (
        <div className="signup-drawer signup-drawer--easy signup-drawer--personal">
            <div className={`signup--${viewSize} signup--easy-membership`}>
                {viewSize === 'desktop' ? (
                    <div className="signup-drawer__header">
                        <p>{trans('Personal Information')}</p>
                        <DrawerCloseButton/>
                    </div>
                ) : (
                    <div className="signup__header--mobile">
                        {trans('Personal Information')}
                        <DrawerCloseButton/>
                    </div>
                )}
                <div className="signup__container">
                    <div className="signup__form easy-membership-personal">
                        {viewSize === 'desktop' && (
                            <div className="signup__form-header">{trans('Personal info')}</div>
                        )}
                        <ValidationGroup ref={formRef}>
                            <FormSecondPart
                                form={form}
                                setForm={setForm}
                                serverResponseErrors={serverResponseErrors}
                                serverValidationCheck={serverValidationCheck}
                                clearServerError={clearServerError}
                                easyMembership={true}
                            />
                            <div className="signup__footer">
                                <LLBtn2
                                    customClasses={`signup__sumbit-btn easy-membership-personal__submit`}
                                    disabled={isSubmitFetching}
                                    onClick={() => {
                                        if (isSubmitFetching) return;
                                        const result = formRef.current?.instance?.validate();
                                        if (result?.isValid) {
                                            submit();
                                        }
                                    }}
                                >
                                    <span className="easy-membership-cta__label">{trans('Save my information')}</span>
                                </LLBtn2>
                            </div>
                        </ValidationGroup>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default EasyMembershipPersonalForm;
